module.exports = __webpack_public_path__ + "static/media/slider2img.5c55cab9.jpg";